export const formatNumberWithComma = ({value, hasPercentage}) => {
  value = value < 100 && value > 0 ? Number(value.toFixed(2)) : Number(value.toFixed(0));
  hasPercentage = hasPercentage ? "%" : ""
  return value.toLocaleString("en-IN") + hasPercentage;
};

export const convertToTitleCase = (inputString) => {
  if (/[a-z][A-Z]/.test(inputString)) {
    inputString = inputString.replace(/([a-z])([A-Z])/g, "$1 $2");
  } else if (/_/.test(inputString)) {
    inputString = inputString.replace(/_/g, " ");
  }

  const titleCaseString = inputString?.replace(/\b\w/g, (match) =>
    match.toUpperCase()
  );

  return titleCaseString;
};
